// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__2QBJc","containerItemsCenter":"Skeleton_containerItemsCenter__1kd6G"};